import formatDate from 'date-fns/format'

# Format a date (as a string) into a terse form
export smallDate = (date) -> formatDate new Date(date), "MM.dd.yyyy"
